import React from "react";
import {Button} from "../../../buttons";
import {t} from "i18next";

import downIcon from "../../../../assets/images/moveLayerDown.svg";

const DownloadProductsAsXlsx: React.FC = () => {
    return (
        <Button
            appearance="primary"
            clickHandler={(e) => console.log(e)}
        >
            <div className="flex justify-around items-center">
                <img src={downIcon} className="w-4 h-4 mr-2" />
                <span>{t<string>("Выгрузить товары", {ns: "messages"})}</span>
            </div>
        </Button>
    )
}

export  default DownloadProductsAsXlsx;